import React from "react";
import Header from "../components/Header";
import { link } from "react-router-dom";
import Footer from "../components/Footer";

function Trademark() {
  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/privacy", label: "Data Privacy Policy" },
    { to: "/get-in-touch", label: "Get in touch" },
  ];

  return (
    <>
      <Header links={navLinks} />

      <main>
        <section class="bg-white dark:bg-gray-900">
          <div class="max-w-screen-xl px-4 py-10 mx-auto lg:py-24 lg:px-6 text-center">
            <div class="max-w-screen-md mx-auto mb-8 text-left lg:mb-12">
              <h2 class="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">Trademark Attribution</h2>
              <div>
                <p>Please see trademark attributions for logos and images used.</p>

                <div class="section">
                  <br />
                  <h2><strong>1. Nvidia</strong></h2>
                  <p>© 2023 NVIDIA, the NVIDIA logo, and NVIDIA Inception Program logo are trademarks and/or registered trademarks of NVIDIA Corporation in the U.S. and other countries.</p>

                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default Trademark;

